<template>
  <section class="section" id="vendings-panel">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <vendings-title @get-vendings="getVendings" />

      <h2 v-if="companyInfo.isCacauShowHeadquarter" class="has-text-centered">
        <b-select v-model="vendingsList" @input="getVendings">
          <option value="ownVendings">
            {{ storeBeingManaged.storeInfo.name }}
          </option>

          <option value="childrenVendings">
            {{ $t("vending.childrenVendings") }}
          </option>
        </b-select>
        <br />
      </h2>

      <h2 v-else class="subtitle has-text-centered">
        {{ storeBeingManaged.storeInfo.name }}
      </h2>

      <p v-if="vendings.length === 0" class="has-text-centered">
        {{ $t("vending.noVendings") }}
      </p>

      <div v-else>
        <vending-card
          v-for="v in vendings"
          :key="v._id"
          :vending="v"
          @edit-vending="editVending"
        />
      </div>
    </div>

    <b-modal
      :active.sync="isVendingModalActive"
      :full-screen="form === 'products'"
    >
      <vending-modal :form="form" @get-vendings="getVendings" />
    </b-modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import vendingsTitle from "./VendingsTitle";
import vendingCard from "./VendingCard";
import vendingModal from "./VendingModal";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false,
      isVendingModalActive: false,
      form: "",
      vendingsList: "ownVendings"
    };
  },

  components: {
    vendingsTitle,
    vendingCard,
    vendingModal
  },

  methods: {
    getVendings() {
      this.isLoading = true;
      this.$store
        .dispatch("getVendings", {
          storeId: this.storeBeingManaged._id,
          vendingsList: this.vendingsList
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    editVending(data) {
      this.form = data.form;

      this.isLoading = true;
      this.$store
        .dispatch("getVending", data.vending._id)
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$store.dispatch(
              "setVendingBeingManaged",
              JSON.parse(JSON.stringify(res.data.payload.vending))
            );
            this.isVendingModalActive = true;
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["storeBeingManaged", "vendings", "companyInfo"])
  },

  mounted() {
    this.getVendings();
  }
};
</script>

<style scoped>
#vendings-panel {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
</style>
